import React, { useEffect, useState, useRef, ReactNode } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import Badge from 'react-bootstrap/Badge';
import Alert from 'react-bootstrap/Alert';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import SAlert from '../../../components/SAlert';
import { MONTHS, URLS } from '../../../resources/constants'
import { glClassificationApi } from '../../../resources/hooks/api/glClassificationApi';
import { useChartAccountApi } from '../../../resources/hooks/api/chartAccountApiHook';

import { getBranch } from '../../../store/user/selectors'
import { getFirstLoginStatus } from '../../../store/settings/selectors'

import '../GlClassification.css'

interface Props {

}

const RevenueGlClassificationStatus: React.FC<Props> = () => {
    const { t } = useTranslation('scenes.glclassification.revenue');
    const { classificationListStatus, completeStep } = glClassificationApi();
    const navigate = useNavigate();

    const branchData = useSelector(getBranch)
    const userStepStatus = useSelector(getFirstLoginStatus);

    const [records, setRecords] = useState<any | null>(null);
    const [months, setMonths] = useState<any | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [userStepCompleted, setUserStepCompleted] = useState<number>(userStepStatus);
    const [contentMaxHeight, setContentMaxHeight] = useState<number>(0);

    useEffect(() => {
        const months = MONTHS.reduce((a: any, c: any) => {
            a = {
                ...a,
                [+c['value']]: c['label']
            }
            return a;
        }, {})
        setMonths(months);

        fetchList();
    }, [])
    useEffect(() => {
        setUserStepCompleted(userStepStatus)
    }, [userStepStatus])

    useEffect(() => {
        // Set up interval to fetch data every 10 seconds without loader
        const interval = setInterval(() => {
            fetchListWithoutLoader();
        }, 10000); // 10000ms = 10 seconds

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, [branchData])

    const fetchList = () => {
        setIsLoading(true);
        classificationListStatus({ account_type: 3, branch_id: +branchData['id'] }, (message: string, resp: any) => {
            setIsLoading(false);
            setRecords(resp.data.data.transactions);
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }

    const fetchListWithoutLoader = () => {
        classificationListStatus({ account_type: 3, branch_id: +branchData['id'] }, (message: string, resp: any) => {
            setRecords(resp.data.data.transactions);
        }, (message: string, resp: any) => {
            toast.error(message);
        })
    }

    const completeCurrentStep = () => {
        setIsLoading(true);
        completeStep({ branch_id: +branchData['id'], type: 2, step: 1 }, (message: string, resp: any) => {
            setIsLoading(false);
            navigate(URLS.DASHBOARD)
        }, (message: string, resp: any) => {
            setIsLoading(false);
            toast.error(message);
        })
    }

    return (
        <div className="main-container flex-grow-1">
            <div className="container-fluid">
                <div className="pb-4 pt-3" id="ux_page_title">
                    <div className="row align-items-center">
                        <div className="col-sm-6 page-title align-items-center d-flex">
                            <h1 className="h3 font-weight-700 mb-0 d-inline-flex">{t('status.title')}</h1>
                        </div>
                        {/* <div className="col-sm-6 justify-content-end align-items-center d-flex">
                            <Link to={URLS.DASHBOARD} className="btn btn-link">{t('button.back_dashboard')}</Link>
                        </div> */}
                    </div>
                </div>

                {
                    userStepCompleted == 0 && records && records.length == 0 ? (
                        <Alert variant={'info'}>
                            <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i>&nbsp;&nbsp;
                            {t('alert.close_month')}
                        </Alert>
                    ) : userStepCompleted >= 3 && records && records.length == 0 ? (
                        <Alert variant={'info'}>
                            <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i>&nbsp;&nbsp;
                            {t('alert.nothing_to_classify')}
                        </Alert>
                    ) : <></>
                }

                <div className=" executive-dashboard">
                    <div className="dashboard-top-part">
                        <div className={`page-loader ${isLoading ? 'visible' : ''}`}>
                            <div className="loader"></div>
                        </div>
                        <div className="table-responsive list-table table-scroll">
                            <table className="table table-default">
                                <thead>
                                    <tr className="align-middle">
                                        <th className="text-center">{t('table.month')}</th>
                                        <th className="text-center">{t('table.year')}</th>
                                        <th className="text-center">{t('table.status')}</th>
                                        <th className="text-center">{t('table.action')}</th>
                                        <th className="text-center">{t('table.ai_status')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        records && records.map((data: any, index: number) => (
                                            <tr className="align-middle h-60" key={index}>
                                                <td className="text-center">
                                                    {months[data['item']['month']]}
                                                </td>
                                                <td className="text-center">
                                                    {data['item']['year']}
                                                </td>
                                                <td className="text-center">
                                                    <h6>
                                                        {data['status'] == 'posted' ? <Badge bg="success">{t('status.completed')}</Badge> : data['status'] == 'partial_posted' ? <Badge bg="warning">{t('status.pending')}</Badge> : <Badge bg="warning">{t('status.pending')}</Badge>}
                                                    </h6>
                                                </td>
                                                <td className="text-center">
                                                    {
                                                        data['status'] != 'posted' ? 
                                                            <Link to={'/deposit-gl-classification/' + data['item']['month'] + '/' + data['item']['year']}>{t('button.classify')}</Link> : 
                                                            <span>{t('status.na')}</span>
                                                    }
                                                </td>
                                                <td className="text-center">
                                                    <h6>
                                                        {data?.['ai_classification_status'] == 2 ? 
                                                            <Badge bg="danger">{t('status.ai.failed')}</Badge> : 
                                                            data?.['ai_classification_status'] == 1 ? 
                                                                <Badge bg="success">{t('status.ai.completed')}</Badge> : 
                                                                <Badge bg="warning">{t('status.ai.pending')}</Badge>
                                                        }
                                                    </h6>
                                                </td>
                                            </tr>))
                                    }
                                    {
                                        (records && records.length == 0) && (
                                            <tr>
                                                <td colSpan={5} className='text-center'>
                                                    <p>{t('alert.no_records_to_classify')}</p>
                                                    {
                                                        userStepCompleted < 3 && (
                                                            <button className='btn btn-cancel' onClick={completeCurrentStep}>{t('button.skip_step')}</button>
                                                        ) || <></>
                                                    }
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        {/* <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} recordPerPage={recordPerPage} lastIndex={lastIndex} firstIndex={firstIndex} npage={npage} /> */}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default RevenueGlClassificationStatus;